// copy from https://github.com/classi/x-ngx-google-analytics/blob/%40classi/ngrx-extensions%403.0.0/projects/ngrx-extensions/src/lib/utils/create-feature-store-selector.ts
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

type MapFn<T, U> = (from: T) => U;
type AnyTypeStore = Store<any>;

export type FeatureStoreSelector<R> = <S>(
  store: AnyTypeStore,
  mapFn: MapFn<R, S>
) => Observable<S>;

export const createFeatureStoreSelector = <R>(
  name: string
): FeatureStoreSelector<R> => {
  return <S>(store: AnyTypeStore, mapFn: MapFn<R, S>) => {
    return store.select(createSelector(createFeatureSelector<R>(name), mapFn));
  };
};
